/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import { Role, RoleFromJSON, RoleFromJSONTyped, RoleToJSON } from "./Role";
import {
	StudentYearEnum,
	StudentYearEnumFromJSON,
	StudentYearEnumFromJSONTyped,
	StudentYearEnumToJSON,
} from "./StudentYearEnum";

/**
 *
 * @export
 * @interface AnnouncementCreateUpdateDTO
 */
export interface AnnouncementCreateUpdateDTO {
	/**
	 *
	 * @type {string}
	 * @memberof AnnouncementCreateUpdateDTO
	 */
	title?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof AnnouncementCreateUpdateDTO
	 */
	description?: string | null;
	/**
	 *
	 * @type {Date}
	 * @memberof AnnouncementCreateUpdateDTO
	 */
	validFrom?: Date;
	/**
	 *
	 * @type {Date}
	 * @memberof AnnouncementCreateUpdateDTO
	 */
	validTo?: Date;
	/**
	 *
	 * @type {Role}
	 * @memberof AnnouncementCreateUpdateDTO
	 */
	recipientRole?: Role;
	/**
	 *
	 * @type {Array<string>}
	 * @memberof AnnouncementCreateUpdateDTO
	 */
	faculties?: Array<string> | null;
	/**
	 *
	 * @type {Array<string>}
	 * @memberof AnnouncementCreateUpdateDTO
	 */
	departments?: Array<string> | null;
	/**
	 *
	 * @type {Array<string>}
	 * @memberof AnnouncementCreateUpdateDTO
	 */
	studyPrograms?: Array<string> | null;
	/**
	 *
	 * @type {Array<StudentYearEnum>}
	 * @memberof AnnouncementCreateUpdateDTO
	 */
	years?: Array<StudentYearEnum> | null;
	/**
	 *
	 * @type {Array<string>}
	 * @memberof AnnouncementCreateUpdateDTO
	 */
	studyCycles?: Array<string> | null;
	/**
	 *
	 * @type {Array<string>}
	 * @memberof AnnouncementCreateUpdateDTO
	 */
	targetCompanyIds?: Array<string> | null;
}

export function AnnouncementCreateUpdateDTOFromJSON(
	json: any
): AnnouncementCreateUpdateDTO {
	return AnnouncementCreateUpdateDTOFromJSONTyped(json, false);
}

export function AnnouncementCreateUpdateDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): AnnouncementCreateUpdateDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		title: !exists(json, "title") ? undefined : json["title"],
		description: !exists(json, "description") ? undefined : json["description"],
		validFrom: !exists(json, "validFrom")
			? undefined
			: new Date(json["validFrom"]),
		validTo: !exists(json, "validTo") ? undefined : new Date(json["validTo"]),
		recipientRole: !exists(json, "recipientRole")
			? undefined
			: RoleFromJSON(json["recipientRole"]),
		faculties: !exists(json, "faculties") ? undefined : json["faculties"],
		departments: !exists(json, "departments") ? undefined : json["departments"],
		studyPrograms: !exists(json, "studyPrograms")
			? undefined
			: json["studyPrograms"],
		years: !exists(json, "years")
			? undefined
			: json["years"] === null
			? null
			: (json["years"] as Array<any>).map(StudentYearEnumFromJSON),
		studyCycles: !exists(json, "studyCycles") ? undefined : json["studyCycles"],
		targetCompanyIds: !exists(json, "targetCompanyIds")
			? undefined
			: json["targetCompanyIds"],
	};
}

export function AnnouncementCreateUpdateDTOToJSON(
	value?: AnnouncementCreateUpdateDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		title: value.title,
		description: value.description,
		validFrom:
			value.validFrom === undefined ? undefined : value.validFrom.toISOString(),
		validTo:
			value.validTo === undefined ? undefined : value.validTo.toISOString(),
		recipientRole: RoleToJSON(value.recipientRole),
		faculties: value.faculties,
		departments: value.departments,
		studyPrograms: value.studyPrograms,
		years:
			value.years === undefined
				? undefined
				: value.years === null
				? null
				: (value.years as Array<any>).map(StudentYearEnumToJSON),
		studyCycles: value.studyCycles,
		targetCompanyIds: value.targetCompanyIds,
	};
}
